import { PrizesItem } from '@/app/entities/Raffle'

interface PrizeListProps {
  prizes: PrizesItem[]
}

const PrizeList = ({ prizes }: PrizeListProps) => {
  return (
    <div>
      <h2 className="mb-4 text-2xl font-semibold">Prêmios</h2>
      <ul>
        {prizes?.map((prize, index) => (
          <li key={prize._id} className="mb-4 w-full rounded-xl border p-5">
            <div className="flex items-center gap-4">
              <span className="rounded-full bg-primary px-4 py-2 font-semibold text-white">
                {index + 1}º Ganhador
              </span>
              <span className="text-lg font-semibold">{prize.name}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default PrizeList
